import { cn } from '@/frontend/lib/utils'

import type { FieldLayoutProps } from './form-layout-context'

/**
 * Inline layout: [Label | Control] on one row
 * Description and error below
 */
export function InlineLayout({
  label,
  description,
  control,
  error,
  className,
  reverseLayout,
}: FieldLayoutProps) {
  return (
    <div className={cn('w-full space-y-1', className)}>
      <div
        className={cn(
          'flex gap-4',
          reverseLayout ? 'items-center flex-row-reverse justify-end' : 'items-start'
        )}
      >
        {(label || description) && (
          <div className={cn('space-y-1', reverseLayout ? 'min-w-0' : 'w-1/3 shrink-0')}>
            {label}
            {description}
          </div>
        )}
        <div className={cn('min-w-0', reverseLayout ? 'flex-none' : 'flex-1 [&>*]:w-full')}>
          {control}
        </div>
      </div>
      {error && !reverseLayout && <div className="ml-[calc(33.333%+1rem)]">{error}</div>}
      {error && reverseLayout && <div>{error}</div>}
    </div>
  )
}
